import { useEffect, useState } from "react"

import { Auth0Provider } from "@auth0/auth0-react"
import { Slot } from "expo-router"

import { DialogContextProvider } from "wealthmode-frontend/context"
import { Box, GluestackUIProvider, Spinner } from "wealthmode-frontend/gluestack/ui"

import "~/global.css"

import { Config } from "@/Config"
import { ColorModeProvider, useColorMode } from "@/context"

export default function RootLayout() {
  return (
    <ColorModeProvider>
      <Root />
    </ColorModeProvider>
  )
}

function Root() {
  const [loading, setLoading] = useState(true)
  const { colorMode } = useColorMode()

  useEffect(() => {
    // Load config first
    Config.load()
      .then(() => {
        setLoading(false)
      })
      .catch((err) => {
        alert("Error loading backend config, please try again later.")
        console.error("Error loading backend config: ", err)
      })
  }, [])

  if (loading) {
    return (
      <Box className="bg-background-primary min-h-screen flex items-center justify-center">
        <Spinner size="large" />
      </Box>
    )
  }

  const cfg = Config.get("auth0") as {
    domain: string
    client_id: string
  }

  return (
    <GluestackUIProvider mode={colorMode}>
      <Auth0Provider
        domain={cfg.domain}
        clientId={cfg.client_id}
        authorizationParams={{
          redirect_uri: window.location.origin,
          screen_hint: "login",
          prompt: "login",
        }}
        cacheLocation="localstorage"
      >
        <DialogContextProvider>
          <Slot />
        </DialogContextProvider>
      </Auth0Provider>
    </GluestackUIProvider>
  )
}
